export default __webpack_public_path__ + "static/media/testimonial-white.ec59385a.svg";